import { artists } from "@/constants/artists/artists";
import { Artist } from "@/types/types";

export const getArtist = (id: string): Artist | null => {
  const foundArtist = artists.find((artist) => artist.id === id);

  if (foundArtist !== undefined) {
    return foundArtist;
  }
  return null;
};
